/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_Buyer_Name_ErrorInputs */

const en_invoice_request_buyer_name_error = /** @type {(inputs: Invoice_Request_Buyer_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write whose name the invoice should carry`)
};

const pl_invoice_request_buyer_name_error = /** @type {(inputs: Invoice_Request_Buyer_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz, na kogo ma być faktura`)
};

/**
* | output |
* | --- |
* | "Write whose name the invoice should carry" |
*
* @param {Invoice_Request_Buyer_Name_ErrorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_buyer_name_error = /** @type {((inputs?: Invoice_Request_Buyer_Name_ErrorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_Buyer_Name_ErrorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_buyer_name_error(inputs)
	return en_invoice_request_buyer_name_error(inputs)
});